import * as React from 'react';

import * as styles from './styles.css';

export const DefaultPreview: React.VFC = () => {
  return <div className={styles['image']} />;
};
